import { RefObject, useEffect, useRef } from 'react';

import { useParams } from 'react-router-dom';
import { StaticPagesContext } from '../../../contexts';
import {
	SlStaticPagesActionTypes,
	StaticPagesActionsService,
} from '../../../services/static-pages/sl-static-pages-actions.service';
import {
	LanguageLandingPage,
	LanguageLandingSectionType,
	RequestType,
} from '../../../global-interfaces';
import { useIsVisibleHook } from '../../../../../shared/public/SlHooks/useIsVisibleHook';
import { Container } from '../../../../../symphony';

export const useSectionViewTracking = ({
	ref,
	sectionName,
	sectionType = LanguageLandingSectionType.Custom,
	sectionTitle,
}: {
    ref: RefObject<HTMLElement>;
    sectionName: LanguageLandingPage;
    sectionType?: LanguageLandingSectionType;
    sectionTitle: string;
}) => {
	const isVisible = useIsVisibleHook(ref, 0, false, '80% 0px 0px');
	const viewedSections = useRef(null);
	const { languageAlias } = useParams();

	useEffect(() => {
		if (!viewedSections.current?.[sectionName] && isVisible) {
			const { actions$ } = Container.take(
				StaticPagesContext,
				StaticPagesActionsService,
			);
			actions$.next({
				type: SlStaticPagesActionTypes.languageLandingSectionView,
				requestType: RequestType.Parallel,
				data: {
					sectionType,
					sectionTitle,
					languageAlias,
				},
			});

			viewedSections.current = {
				...viewedSections.current,
				[sectionName]: true,
			};
		}
	}, [isVisible]);
};
